module.exports = "<p>\r\n  footer works!\r\n</p>\r\n"